import RotateRandomizedText from '../../../../../common/footer/RotateRandomizedText'

export default RotateRandomizedText
